import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { columns } from './constants'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { GetMemberLoginHistoryTableData } from '@/modules/manage-member/type'

interface MemberLoginLogTableProps {
	data: GetMemberLoginHistoryTableData[]
	total: number
	isLoading?: boolean
}

export default function MemberLoginLogTable({
	data,
	total,
	isLoading,
}: MemberLoginLogTableProps) {
	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch placeHolder="ค้นหาชื่อผู้ใช้งาน" />
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
